import { get } from '@eika-infrastruktur/request';

import type { InvoiceDocument, InvoiceDocumentId } from '../generated-types';
import { CONTEXT_PATH } from './index';

const SERVICE_PATH = 'rest/resource/invoicearchive';

export const getInvoiceArchive = (): Promise<InvoiceDocument[]> => {
    return get<InvoiceDocument[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/`);
};

export const getInvoiceUrl = (invoiceDocumentId: InvoiceDocumentId): Promise<string> => {
    return get<string>(`${CONTEXT_PATH}/${SERVICE_PATH}/${invoiceDocumentId.value}`);
};
